/*------------------------------------*\
    MODULES
\*------------------------------------*/

var debounce = require('debounce');

/*------------------------------------*\
    HERO MODULE
\*------------------------------------*/
class Hero {
    constructor(passedElement) {
        let self = this;

        self.elem = passedElement;
    }

    init() {
        let self = this;

        window.addEventListener("scroll", self.parallax);
        window.onresize = debounce(self.parallax, 200);
    }

    parallax() {
        let self = this;

        let hero = document.querySelector("[data-hero-image]");
        let coords;

        let yPos = window.pageYOffset / hero.dataset.speed;
        yPos = yPos;


        if (window.innerWidth > 991) {
            coords = '50% ' + yPos + 'px';
        } else if (window.innerWidth < 991) {
            coords = '70% ' + yPos + 'px';
        }


        hero.style.backgroundPosition = coords;

    }
}

export default Hero;